module.exports = __webpack_public_path__ + "static/media/event.e1f028cc.svg";